import { TripCommentModel } from './tripcomment.model';
import { AuthService } from '../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, RequestOptionsArgs, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { JQueryHelperService } from '../../shared/models/jquery-helper.service';

@Injectable()
export class TripCommentService {
  JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) {}

  public AddTripComment(formData: FormData): Observable<IAPIResponse> {
    return Observable.create((observer: any) => {
      let url: string = WeGoConfig.API_SET_TRIP_COMMENT;
      let xhr: XMLHttpRequest = new XMLHttpRequest();
      let header = this.authService.GetHeaderForFile();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.status);
          }
        }
      };

      xhr.open("POST", url, true);
      for (let i = 0; i < header.length; i++) {
        xhr.setRequestHeader(header[i]["name"], header[i]["value"]);
      }
      xhr.send(formData);
    });
  }

  public GetTripComment(tripId: string): Observable<IAPIResponse> {
    if ( tripId != "" ) {
      let getGetTripCommentUrl = WeGoConfig.API_GET_TRIP_COMMENT + "?tripId=" + tripId;

      let headers = this.authService.GetHeader();
      let options = new RequestOptions({ headers: headers });
      return this.http
        .get(getGetTripCommentUrl, options)
        .map(this.authService.HandleAPIResponse)
        .catch(this.authService.HandleAPIError);
    }
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/tripdatareport/models/tripcomment.service.ts